<img [src]="'assets/images/icons/lightning.svg'" class="optimization-progress__lightning"/>
<p *ngIf="!!websiteUrl" class="website-title mb14">
  <i class="db-icon db-icon-ds-globe"></i>
  <span>{{websiteUrl}}</span>
</p>
<h3>Your {{userSubscription?.trialBoosterClient ? 'homepage' : 'website'}} is being<br/> optimized right now</h3>
<p class="mt4 db-desc" *ngIf="!userLocalStorage?.verifyEmailErrorClosed && websitesCount < 2
    && !Config.photoGalleryPluginIds.includes(userSubscription?.product_id)">
  In the meantime, please verify your account<br/> from the email we sent you.
</p>
<div class="optimization-progress__list mt40">
  <div *ngFor="let step of steps; let i = index"
     [ngClass]="{'done' : i < currentStep, 'loading' : i === currentStep}">

    <i *ngIf="i < currentStep" class="db-icon db-icon-ds-checkmark"></i>
    <i *ngIf="i > currentStep" class="circle"></i>
    <span *ngIf="i === currentStep" class="ds-spinner-circle"></span>

    <div class="optimization-progress__step">
      <span [ngClass]="{'next-step': i > currentStep}">{{step}}</span>
      <!--  <db-progress-bar class="mt10" size="sm" [state]="'success'" [progressPercent]="progress" *ngIf="i === steps?.length - 1 && currentStep === steps?.length - 1"></db-progress-bar>
      <span class="completed_percent mt6" *ngIf="i === steps?.length - 1 && currentStep === steps?.length - 1">{{progress}}% completed</span>-->
    </div>
  </div>
</div>
